<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';
    import ButtonMain from '../ButtonMain.svelte';
    import Button from '../../components/Vehicles/Button.svelte';
    import ButtonBack from '../ButtonBack.svelte';
    import MessageInline from '../Messages/MessageInline.svelte';
    import TemplateRow from '../TemplateRow.svelte';
    import ButtonRemove from '../ButtonRemove.svelte';
    import ButtonSmallBlack from '../ButtonSmallBlack.svelte';

    export let isOpen: boolean = false;
    export let component: any;
    export let componentProps: any;
    export let modeView: 'white' | 'analytics' = 'white';
    export let showButtonOk: boolean = true;

    export let onClick: () => void = () => {};
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents modeView-{modeView}">
            <svelte:component this={component} {componentProps} />
            {#if showButtonOk}
                <div class="actions">
                    <ButtonSmallBlack
                        text={$_('Close')}
                        on:click={() => {
                            closeModal();
                            onClick();
                        }}
                    />
                </div>
            {/if}
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        width: 890px;
        height: 680px;
        max-width: 95vw;
        max-height: 95vh;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
        /*border: 3px solid var(--automapa-blue);*/
        box-shadow:
            0 0 0 10px #1c5dc722,
            0 4px 8px rgba(0, 0, 0, 0.2);
    }
    .contents.modeView-analytics {
        padding: 0;
        width: unset;
        height: unset;
    }

    .actions {
        margin-top: 32px;
        display: flex;
        justify-content: center;
        column-gap: 10px;
    }
</style>
